const getQuickAction = (quickActions: any, action: string) => {
  const nAction =
    quickActions && quickActions.length > 0
      ? quickActions.filter((qaItem: any) => qaItem.type === action)
      : [];
  return nAction.length === 0 ? false : nAction?.[0]?.enabled;
};

export default getQuickAction;
